var exports = {
  "r": "hideLeadingVisual__8Wze4x",
};

module.exports = exports;
